<template>
    <div class="info-modal hide">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <center>
                <span class="study-tab">Pivotal Study 1 Design<sup>1,2</sup></span>
            </center>

            <div class="study-content">
                <p>2 distinct study phases</p>

                <ul>
                    <li>Open-label treatment optimization phase (6 weeks)</li>
                    <li>Double-blind controlled test phase (1 week) in which patients were randomized to continue taking
                        JORNAY PM or switched to placebo</li>
                </ul>

                <p>N=117 (JORNAY PM: n=64; placebo: n=53)</p>

                <p style="font-size: 16px;">
                    <b>Primary endpoint:</b> SKAMP* <br />
                    <b>Secondary endpoints:</b> PREMB-R AM, PREMB-R PM
                </p>

                <p class="refs" style="font-size:10px;">*The model-adjusted average of all post-dose SKAMP combined
                    scores measured during the
                    12-hour analog testing period.</p>

            </div>
            <center>
                <p class="refs" style="max-width:650px; margin: 10px auto;">PREMB-R AM, Parent Rating of Evening and
                    Morning Behavior-Revised, Morning; PREMB-R PM, Parent Rating
                    of Evening and Morning Behavior-Revised, Evening;
                    SKAMP, Swanson, Kotkin, Agler, M-Flynn, and Pelham Scale.
                </p>
            </center>

            <div class="study-refs">
                <p><b>References: 1.</b> JORNAY PM<sup>®</sup> [package insert]. Ironshore Pharmaceuticals &
                    Development,
                    Inc. <b>2.</b>
                    Childress
                    AC, Cutler AJ, Marraffino A, et al. A randomized, double-blind, placebo-controlled study of HLD200,
                    a
                    delayed-release and extended-release methylphenidate, in children with
                    attention-deficit/hyperactivity
                    disorder: an evaluation of safety and efficacy throughout the day and across settings. <i>J Child
                        Adolesc
                        Psychopharmacol.</i> 2020;30(1):2-14.
                </p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>

<style lang="scss" scoped>
.info-modal-content * {
    font-weight: 600;
}

.info-modal-content strong,
.info-modal-content b {
    font-weight: 800;
}
</style>